export default __webpack_public_path__ + "static/media/project_cadefi_0.c7d7eaf7.png";